import React, { useState } from "react";
import If from "../../../vendors/components/If";
import InnerHtml from "../inner-html";

interface Props {
  value: any;
  maxLength: any;
  labelClassName?: any;
}

export default function LerMais({ value, maxLength, labelClassName }: Props) {
  const [show, setShow] = useState(false);

  const toPlainText = (html: string) => {
    const div = document.createElement("div");
    div.innerHTML = html ?? "";
    return div.textContent || div.innerText || "";
  };

  const text = toPlainText(value);

  const toggle = (event: any) => {
    event.stopPropagation();
    event.preventDefault();
    setShow(!show);
  };

  if (!text || text.length <= maxLength) {
    return (
      <div className="ecf-textarea--readonly">
        <InnerHtml value={value} />
      </div>
    );
  }

  return (
    <div className="ecf-textarea--readonly">
      <If condition={!show}>
        <p className={labelClassName} style={{ margin: 0 }}>
          {text.substring(0, maxLength)}...{" "}
          <a href="#" onClick={toggle} className="ecf-ler-mais__link">
            expandir
          </a>
        </p>
      </If>
      <If condition={show}>
        <InnerHtml value={value} />{" "}
        <a href="#" onClick={toggle} className="ecf-ler-mais__link">
          comprimir
        </a>
      </If>
    </div>
  );
}
